
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.254 5.925a.75.75 0 00-.004.09v12.972a.746.746 0 00.371.66.745.745 0 00.765-.004 8.25 8.25 0 018.228 0 .747.747 0 00.772 0 8.25 8.25 0 018.228 0 .748.748 0 00.993-.203.747.747 0 00.143-.453V6.014a.746.746 0 00-.388-.67 9.75 9.75 0 00-9.362-.2 9.75 9.75 0 00-9.362.2.752.752 0 00-.384.58zm17.996.52a8.25 8.25 0 00-7.5 0v11.35a9.75 9.75 0 017.5 0V6.444zm-9 0v11.35a9.75 9.75 0 00-7.5 0V6.444a8.25 8.25 0 017.5 0z"}})])
          )
        }
      }
    